<template>
  <div>
    <div class="tag-input form-control" tabindex="0" v-if="hasTag">
      <span class="tag">{{value}}<a href="javascript:" @click="removeTag"><span class="fas fa-times"></span></a></span>
    </div>
    <input
      type="text"
      class="form-control"
      :placeholder="placeholder"
      ref="input"
      required
      @input="updateValue($event.target.value)"
      @keydown.down="focusMenu"
      @keydown.esc="hideDropDown"
      @keyup="showDropDown"
      :value="value"
      v-else
    >
    <div class="invalid-feedback">{{placeholder}} is required.</div>
    <div
      class="dropdown-menu"
      :class="{show: isDropdownVisible}"
      ref="dropdownMenu"
      @keydown.down="focusNext"
      @keydown.up="focusPrev"
      @keydown.esc="hideDropDown"
    >
      <h6 class="dropdown-header">Company suggestions
        <a href="javascript:" class="dismiss float-right" @click="hideDropDown"><span class="fas fa-times"></span>
          DISMISS</a>
      </h6>
      <a class="dropdown-item" @click="selectItem(company)" href="javascript:" v-for="company in companySuggestions"
         ref="menuItem" :key="company.company_number">
        <span :class="{bold: isNameSearch}">{{company.title}}</span> (<span :class="{bold: !isNameSearch}">{{company.company_number}}</span>)
      </a>
    </div>
  </div>
</template>

<script>
  import BaseTagInput from '@/components/BaseTagInput'
  import Popper from 'popper.js'

  export default {
    computed: {
      isDropdownVisible () {
        return this.companySuggestions.length > 0 && document.activeElement === this.$refs.input
      }
    },
    data () {
      return {
        index: 0
      }
    },
    extends: BaseTagInput,
    methods: {
      focusMenu () {
        this.index = 0
        this.$refs.menuItem[this.index].focus()
      },
      focusNext () {
        if (this.index < this.companySuggestions.length - 1) this.$refs.menuItem[++this.index].focus()
      },
      focusPrev () {
        if (this.index > 0) this.$refs.menuItem[--this.index].focus()
      },
      hideDropDown () {
        this.$emit('hide-dropdown')
      },
      selectItem (item) {
        this.$emit('select-item', item)
      },
      showDropDown (event) {
        document.addEventListener('click', this.hideDropDown, {once: true})
        /* eslint-disable no-new */
        new Popper(this.$refs.input, this.$refs.dropdownMenu, {placement: 'bottom-start'})
        if (event.key ? event.key !== 'Escape' : event.keyCode !== 27) this.$emit('show-dropdown', this.isNameSearch)
      }
    },
    props: {
      companySuggestions: Array,
      isNameSearch: Boolean,
      placeholder: String,
      required: String
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .bold {
    font-weight: bold;
  }

  .dismiss {
    text-decoration: none;
    font-weight: normal;
  }

  .dropdown-menu {
    border: 1px solid #ced4da;
    max-width: 100%;

    .dropdown-item:active {
      background-color: $cyan;
    }
  }
</style>
